export default "/assets/images/smoky-gray.webp?042b2b7810b2ae38256df69a656d3770";